<template>
    <div class="container-fluid py-2 py-md-3 py-lg-4">
        <div class="d-flex align-items-center">
            <h2 class="mb-1">
                {{ title }}
            </h2>
        </div>
        <div class="accordion" itemscope="" itemtype="https://schema.org/FAQPage">
            <div v-for="(faq, index) in faqs" :key="'question-' + index">
                <div
                    class="card multi"
                    itemscope=""
                    itemprop="mainEntity"
                    itemtype="https://schema.org/Question"
                >
                    <div :id="'heading-' + index" class="card-header">
                        <button
                            class="collapsed"
                            data-bs-toggle="collapse"
                            :data-bs-target="'collapse-'+ index"
                            :aria-controls="'#' + 'collapse-'+ index"
                            aria-expanded="false"
                            :data-oevent-category="faq.tms.category"
                            :data-oevent-action="faq.tms.action"
                            :data-oevent-label="faq.tms.label"
                        >
                            <span class="accordion-card-title">
                                <span class="accordion-title" itemprop="name" v-html="faq.question" />
                                <span class="accordion-icon" aria-hidden="true" />
                            </span>
                        </button>
                    </div>
                    <div
                        :id="'collapse-'+ index"
                        class="collapse"
                        :aria-labelledby="'answer-qst-'+ index"
                        itemscope=""
                        itemprop="acceptedAnswer"
                        itemtype="https://schema.org/Answer"
                    >
                        <div class="accordion-card-body standard" itemprop="text">
                            <span v-html="faq.answer" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Faq",
    props: {
        title: {
            type: String,
            required: true
        },
        faqs: {
            type: Array,
            required: true
        }
    }
}
</script>
